// @generated by TypeGen from LogbookModel/AuditLogEdit.swift - DO NOT EDIT

import type { ILogbookModel } from "./Model"

export interface IAuditLogEdit extends ILogbookModel {
  id: number;
  accountId: number;
  shipId: number;
  cruiseId?: number;
  tripId?: number;
  dayId?: number;
  logId?: number;
  sourceId: number;
  sourceType: IAuditLogEditSource;
  shipUserId: number;
  editedAt: string;
  origin: IAuditLogEditOrigin;
  updatedAt: string;
  syncedAt?: string;
  editGroupId: string;
  field: string;
  previousValue?: string;
}

export enum IAuditLogEditOrigin {
  manual = "manual",
  nmea = "nmea",
  system = "system",
}

export enum IAuditLogEditSource {
  log = 1,
  day = 2,
  status = 3,
  test = 100,
}
